/**
 * Centralized constants and helper functions for Book options.
 * Used across BookList, BookDetailModal, ScannedBookDetailModal, and BulkEditModal.
 */

// ============================================================================
// CONSTANTS
// ============================================================================

export const FORMAT_OPTIONS = ['physical', 'digital', 'audiobook'] as const
export const STATUS_OPTIONS = ['owned', 'wanted', 'lent', 'lost'] as const
export const PROGRESS_OPTIONS = ['not_read', 'read', 'reading', 'abandoned'] as const

// ============================================================================
// HELPER TYPES
// ============================================================================

export type FormatOption = typeof FORMAT_OPTIONS[number]
export type StatusOption = typeof STATUS_OPTIONS[number]
export type ProgressOption = typeof PROGRESS_OPTIONS[number]

// ============================================================================
// LABEL HELPERS (Spanish)
// ============================================================================

export const getFormatLabel = (opt: string): string => {
    switch (opt) {
        case 'physical': return 'Físico'
        case 'digital': return 'Digital'
        case 'audiobook': return 'Audiolibro'
        default: return opt
    }
}

export const getStatusLabel = (opt: string): string => {
    switch (opt) {
        case 'owned': return 'Lo tengo'
        case 'wanted': return 'Lo quiero'
        case 'lent': return 'Prestado'
        case 'lost': return 'Perdido'
        default: return opt
    }
}

export const getProgressLabel = (opt: string): string => {
    if (opt === '') return '— No establecido —'
    switch (opt) {
        case 'not_read': return 'No leído'
        case 'reading': return 'Leyendo'
        case 'read': return 'Leído'
        case 'abandoned': return 'Abandonado'
        default: return opt
    }
}
